export enum UserRole {
  DOCTOR = 1,
  ADMIN = 2,
  TECHNICAL = 3,
}
